import PropTypes from 'prop-types';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import themeColors from '../../assets/styles/themeColors';
import AddressForm from '../../components/Forms/AddressForm';
import { HeadingSubtitle } from '../../components/Heading';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import Paragraph from '../../components/Paragraph/Paragraph';
import { SAME_ADDRESS } from '../../constants/sessionStorage';
import useApplicationOwnerName from '../../hooks/useApplicationOwnerName';
import { useMenu } from '../../hooks/useMenu';
import { selectApplication } from '../../store/selectors/applicationSelectors';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import {
  secureAddressEnterSubtitle,
  secureAddressEnterTitle,
} from '../../util/helpers/onboardingContentHelpers';
import { retrieveFromSessionStorage } from '../../util/helpers/sessionStorageHelper';

const AddressEnter = ({ applicantType }) => {
  const { activeMenu, activeItem } = useMenu();
  const applicantName = useApplicationOwnerName(applicantType);
  const Application = useSelector(selectApplication);
  const { ApplicationType } = Application;
  const sameAddress = retrieveFromSessionStorage(SAME_ADDRESS);
  const { t } = useTranslation();
  const { BrokerName } = useSelector(selectSettings);
  const formId = 'address_form';
  const [eventType, setEventType] = useState(null);

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeStep={activeItem}
      previousPath={activeItem?.previousPath}
      formId={formId}
      setEventType={setEventType}
    >
      <Helmet>
        <title>
          {t('secureAddress.titleTag', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <HeadingSubtitle mb={12} color={themeColors.colorTextSecondary}>
        {secureAddressEnterTitle(applicantType, applicantName)}
      </HeadingSubtitle>
      <Paragraph color={themeColors.colorTextXLLight}>
        {secureAddressEnterSubtitle(applicantType, applicantName)}
      </Paragraph>
      <AddressForm
        nextPath={activeItem?.nextPath}
        applicantType={applicantType}
        hasSameAddress={sameAddress}
        applicationType={ApplicationType}
        formId={formId}
        setEventType={setEventType}
        eventType={eventType}
      />
    </OnBoardingContainer>
  );
};

AddressEnter.propTypes = {
  applicantType: PropTypes.string,
};

export default AddressEnter;
